import "./index.scss";
import {
  GeneralMediumFacebook,
  GeneralMediumLinkedin,
  GeneralMediumTwitter,
} from "@wise-emotions/react-icons";
import IconWrap from "components/Icon/IconWrap";
import React from "react";

interface SocialSharesProps {
  socialActive: string[];
  classIcos: string;
}

const SocialShares = (props: SocialSharesProps) => {
  const { socialActive, classIcos } = props;
  let url = "";
  if (typeof document !== "undefined") {
    url = window.location.href;
  }
  return (
    <div className="Share">
      <ul className="Share__list">
        {socialActive?.includes("facebook") && (
          <li>
            <a
              // TODO: add correct aria label ( not hardcoded value )
              aria-label="Facebook"
              rel="noreferrer"
              href={`https://www.facebook.com/sharer.php?u=${url}`}
              target="_blank"
            >
              <div
                className={`Share__social-icon Share__social-icon--facebook ${classIcos}`}
              >
                <IconWrap>
                  <GeneralMediumFacebook aria-label="Facebook" />
                </IconWrap>
              </div>
            </a>
          </li>
        )}
        {socialActive?.includes("linkedin") && (
          <li>
            <a
              // TODO: add correct aria label ( not hardcoded value )
              aria-label="Linkedin"
              rel="noreferrer"
              href={`https://www.linkedin.com/shareArticle?url=${url}`}
              target="_blank"
            >
              <div
                className={`Share__social-icon Share__social-icon--linkedin ${classIcos}`}
              >
                <IconWrap>
                  <GeneralMediumLinkedin aria-label="Linkedin" />
                </IconWrap>
              </div>
            </a>
          </li>
        )}
        {socialActive?.includes("twitter") && (
          <li>
            <a
              // TODO: add correct aria label ( not hardcoded value )
              aria-label="Twitter"
              rel="noreferrer"
              href={`https://twitter.com/share?url=${url}`}
              target="_blank"
            >
              <div
                className={`Share__social-icon Share__social-icon--twitter ${classIcos}`}
              >
                <IconWrap>
                  <GeneralMediumTwitter aria-label="Twitter" />
                </IconWrap>
              </div>
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default SocialShares;
